'use strict';

import React from 'react'
import ReactDOM from 'react-dom'
import { i18n } from 'react-i18n'
import $ from 'jquery'
import LinnerDiv from './lineDiv'
import intialData from '../utility/getTemplateData'
import AppActions from '../actions/AppActions'
import AppStore from '../stores/AppStore';

let PropTypes = React.PropTypes

export default React.createClass({

    mixins: [i18n('common/note')],

    propTypes:{
        label: React.PropTypes.string
    },

    getInitialState () {
		console.log(intialData.donationNote);
        return {
			donationNote: intialData.donationNote || ''
		};
    },

	componentDidMount () {
		if(intialData.donationNote) {
			$('.donate_note_wrapper label').hide()
			$('.donate_note_wrapper .note_wrap').show()
		}
	},

    handleClick (event){
        $('.donate_note_wrapper label').hide()
        $('.donate_note_wrapper .note_wrap').show()
    },

    handleBlur (event){

        if (event.target.value){
            AppActions.changeNote({note: event.target.value});
        } else {
			AppActions.changeNote({note: ''});
            $('.donate_note_wrapper .note_wrap').hide()
            $('.donate_note_wrapper label').show()
        }
    },

	handleKeyPress (event){

		if (event.target.value && event.target.value.length >= 250) {
			$('.note_wrap').addClass('animated shake');
			setTimeout(() => {
				$('.note_wrap').removeClass('animated shake');
			}, 1000);
			return false;
		}
	},

    render () {

        let notelabel = this.i18n('note.label')

        if(intialData.charityNoteEnabled && intialData.charityNoteLabel){
			notelabel = intialData.charityNoteLabel
        }

        return (
        	<div>
	        	<div className="row text-center donate_note_wrapper">
					<div className="note_wrap">
						<textarea
							id="note"
							name="note"
							maxLength="250"
							defaultValue={this.state.donationNote}
							onKeyPress={this.handleKeyPress}
                            onBlur={this.handleBlur}>
						</textarea>
					</div>
					<label htmlFor="note"
                        onClick={this.handleClick}>
						<span className="plus_icon">+</span>{notelabel}
					</label>
				</div>
				<LinnerDiv />
			</div>
        );
    }
});



// WEBPACK FOOTER //
// ./common/note.js